import { Card } from "@radix-ui/themes";
import PropTypes from "prop-types";

TopLeftMapDiv.propTypes = {
  children: PropTypes.node,
};

export default function TopLeftMapDiv({ children }) {
  return (
    <Card
      id="legend"
      style={{
        position: "absolute",
        top: 10,
        left: 10,
        zIndex: 1000,
        backgroundColor: "white",
        borderRadius: "var(--radius-4)",
      }}
    >
      {children}
    </Card>
  );
}
